"use client";

import { ArrowRight, Check, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Coverage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const serviceAreas = ["Garden City", "Dodge City", "Liberal", "Ulysses", "Scott City", "Syracuse"];
  const pins = [{
    id: 1,
    top: "32%",
    left: "48%",
    label: "Headquarters",
    address: "Garden City, KS",
    isHQ: true
  }, {
    id: 2,
    top: "22%",
    left: "62%",
    label: "Scott City",
    address: "Service Area",
    isHQ: false
  }, {
    id: 3,
    top: "55%",
    left: "30%",
    label: "Ulysses",
    address: "Service Area",
    isHQ: false
  }, {
    id: 4,
    top: "68%",
    left: "58%",
    label: "Liberal",
    address: "Service Area",
    isHQ: false
  }, {
    id: 5,
    top: "45%",
    left: "72%",
    label: "Dodge City",
    address: "Service Area",
    isHQ: false
  }, {
    id: 6,
    top: "38%",
    left: "22%",
    label: "Syracuse",
    address: "Service Area",
    isHQ: false
  }];
  return <section data-section-id="892" id="southwest-kansas-roofing-coverage" ref={ref} className="w-full bg-background text-foreground">
      <div className="flex flex-col lg:flex-row w-full">
        {}
        <div className="relative w-full lg:w-3/5 h-[420px] sm:h-[520px] lg:h-[720px] overflow-hidden bg-secondary">
          {}
          <div className="absolute inset-0 bg-gradient-to-br from-secondary via-secondary to-secondary" />

          {}
          <svg className="absolute inset-0 w-full h-full opacity-[0.03]" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <pattern id="bp-grid-small" width="24" height="24" patternUnits="userSpaceOnUse">
                <path d="M 24 0 L 0 0 0 24" fill="none" stroke="currentColor" strokeWidth="0.4" />
              </pattern>
              <pattern id="bp-grid-large" width="120" height="120" patternUnits="userSpaceOnUse">
                <path d="M 120 0 L 0 0 0 120" fill="none" stroke="currentColor" strokeWidth="0.8" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#bp-grid-small)" />
            <rect width="100%" height="100%" fill="url(#bp-grid-large)" />
          </svg>

          {}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 700" preserveAspectRatio="none" aria-hidden="true">
            <path d="M 120 180 L 380 120 L 620 160 L 820 240 L 880 420 L 760 580 L 480 620 L 220 540 L 100 380 Z" fill="hsl(45, 90%, 45%)" fillOpacity="0.04" stroke="hsl(45, 90%, 45%)" strokeWidth="1.2" strokeDasharray="6 6" />
            <path d="M 280 220 L 520 200 L 680 320 L 600 480 L 380 460 Z" fill="none" stroke="hsl(45, 90%, 45%)" strokeWidth="1" strokeDasharray="4 8" strokeOpacity="0.7" />
            <path d="M 180 340 Q 420 280 720 380" fill="none" stroke="hsl(45, 90%, 45%)" strokeWidth="0.8" strokeOpacity="0.5" />
            <path d="M 280 540 Q 500 600 760 500" fill="none" stroke="hsl(45, 90%, 45%)" strokeWidth="0.8" strokeOpacity="0.5" />
          </svg>

          {}
          <div className="absolute top-6 left-6 text-muted-foreground font-mono text-xs tracking-widest">
            <div>37.97° N</div>
            <div className="mt-1">100.87° W</div>
          </div>

          <div className="absolute bottom-6 left-6 text-muted-foreground font-mono text-[10px] tracking-[0.2em] uppercase">
            Service Region Map
          </div>

          <div className="absolute bottom-6 right-6 text-muted-foreground font-mono text-[10px] tracking-[0.2em]">
            SCALE 1:50,000
          </div>

          {}
          {pins.map((pin, i) => <div key={pin.id} data-index={i} className="absolute group" style={{
          top: pin.top,
          left: pin.left,
          transform: "translate(-50%, -100%)"
        }}>
              {}
              <span className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2 block" style={{
            width: pin.isHQ ? "48px" : "32px",
            height: pin.isHQ ? "48px" : "32px",
            background: "hsl(45, 90%, 45%)",
            opacity: 0.35,
            animation: `wwb-pulse 4s ease-out infinite`,
            animationDelay: `${i * 0.6}s`
          }} />
              <span className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2 block" style={{
            width: pin.isHQ ? "24px" : "16px",
            height: pin.isHQ ? "24px" : "16px",
            background: "hsl(45, 90%, 45%)",
            opacity: 0.6,
            animation: `wwb-pulse 4s ease-out infinite`,
            animationDelay: `${i * 0.6 + 0.3}s`
          }} />

              {}
              <div className="relative z-10 flex flex-col items-center cursor-pointer">
                <MapPin className="text-primary drop-shadow-md" fill="hsl(45, 90%, 45%)" strokeWidth={1.5} style={{
              width: pin.isHQ ? "28px" : "18px",
              height: pin.isHQ ? "28px" : "18px"
            }} />
                {pin.isHQ && <span className="mt-0.5 font-mono text-[9px] tracking-[0.2em] uppercase text-white/80">
                    HQ
                  </span>}

                {}
                <div className="pointer-events-none absolute bottom-full mb-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                  <div className="bg-card text-card-foreground px-3 py-2 shadow-lg border-l-2 border-primary">
                    <div className="font-semibold text-xs font-default">{pin.label}</div>
                    <div className="font-mono text-[10px] text-muted-foreground mt-0.5">
                      {pin.address}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}

          <style>{`
            @keyframes wwb-pulse {
              0% { transform: translate(-50%, -50%) scale(0.4); opacity: 0.6; }
              70% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }
              100% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }
            }
          `}</style>
        </div>

        {}
        <div className="w-full lg:w-2/5 bg-card flex items-center">
          <div className={`w-full px-8 py-16 sm:px-12 sm:py-20 lg:px-20 lg:py-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="font-mono text-xs tracking-[0.25em] text-primary">06</span>
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground">
                Service Areas
              </span>
            </div>

            {}
            <h2 className="font-default font-semibold text-foreground leading-[1.1] tracking-tight text-[2rem] sm:text-[2.5rem] lg:text-[2.5rem]">
              Serving Southwest Kansas and beyond.
            </h2>

            {}
            <p className="mt-6 text-base leading-relaxed text-muted-foreground font-default max-w-md">
              Luxury Construction LLC provides professional roofing and real estate solutions across Garden City and a 1.5-hour driving radius.
            </p>

            {}
            <ul className="mt-10 space-y-4">
              {serviceAreas.map((area, i) => <li key={area} data-index={i} className="flex items-center gap-4 group">
                  <span className="flex items-center justify-center w-6 h-6 border border-border bg-background">
                    <Check className="w-3.5 h-3.5 text-primary" strokeWidth={2.5} />
                  </span>
                  <span className="font-default text-foreground text-base sm:text-lg tracking-tight">
                    {area}
                  </span>
                  <span className="flex-1 h-px bg-border/60 ml-2" />
                  <span className="font-mono text-[10px] text-muted-foreground tracking-widest">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </li>)}
            </ul>

            {}
            <div className="mt-12 pt-8 border-t border-border">
              <Link to="/ContactUsPage" className="inline-flex items-center gap-3 text-foreground hover:text-primary transition-colors duration-200 group">
                <span className="font-default text-base font-medium tracking-tight">
                  Outside these areas? Let's talk.
                </span>
                <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}